import CryptoJS from 'crypto-js';
import { ALCATRAZ_CRYPTO_KEY } from './env';
import { cryptoInitialToken } from './constants';

export function setEncryptedData(data, storage) {
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    ALCATRAZ_CRYPTO_KEY,
  ).toString();

  localStorage.setItem(storage, encryptedData);
}

export function getEncryptedData(storage, decryptToken = false) {
  const encryptedData = localStorage.getItem(storage) || '';
  const bytesProfileData = CryptoJS.AES.decrypt(encryptedData, ALCATRAZ_CRYPTO_KEY);
  let dataSelected;
  if (bytesProfileData?.sigBytes > 0 && encryptedData?.startsWith(cryptoInitialToken)) {
    dataSelected = JSON.parse(bytesProfileData.toString(CryptoJS.enc.Utf8));
  }

  if (decryptToken) {
    return dataSelected || encryptedData;
  }
  return dataSelected;
}

const encryptIfNeeded = (value, storage) => {
  const logout = window?.location?.pathname === '/logout' || window?.location?.pathname === '/';
  if (!value?.startsWith(cryptoInitialToken) && !logout) {
    setEncryptedData(value, storage);

    // refresh page after last param update
    if (storage === 'deviceId') {
      window.location.reload();
    }
  }
};

export function decryptAllData() {
  const deviceId = getEncryptedData('deviceId', true);
  localStorage.setItem('deviceId', deviceId);
  const state = getEncryptedData('state', true);
  localStorage.setItem('state', state);
  const renewEntitlements = getEncryptedData('renewEntitlements', true);
  localStorage.setItem(
    'renewEntitlements',
    typeof renewEntitlements === 'string'
      ? renewEntitlements
      : JSON.stringify(renewEntitlements),
  );
  const frToken = getEncryptedData('frToken', true);
  localStorage.setItem('frToken', frToken);
  const modalGranHermanoShownList = getEncryptedData('modalGranHermanoShownList', true);
  localStorage.setItem('modalGranHermanoShownList', modalGranHermanoShownList);
}

export function encryptAllData() {
  const profiles = localStorage.getItem('profiles');
  encryptIfNeeded(profiles, 'profiles');
  const profile = localStorage.getItem('profile');
  encryptIfNeeded(profile, 'profile');
  const state = localStorage.getItem('state');
  encryptIfNeeded(state, 'state');
  const renewEntitlements = localStorage.getItem('renewEntitlements');
  encryptIfNeeded(renewEntitlements, 'renewEntitlements');
  const frToken = localStorage.getItem('frToken');
  encryptIfNeeded(frToken, 'frToken');
  const deviceId = localStorage.getItem('deviceId');
  encryptIfNeeded(deviceId, 'deviceId');
}

// for Feature Flag
export const decryptIfNeeded = (storage) => {
  const value = localStorage.getItem(storage);
  const logout = window?.location?.pathname === '/logout';
  if (typeof (value) !== 'object' && value?.startsWith(cryptoInitialToken) && !logout) {
    const decryptValue = getEncryptedData(storage, true);
    const valueToStore = typeof decryptValue === 'object' ? JSON.stringify(decryptValue) : decryptValue;
    localStorage.setItem(storage, valueToStore);
  }
};

// for Feature Flag
export function decryptAllDataifNeeded() {
  decryptIfNeeded('modalGranHermanoShownList');
  decryptIfNeeded('profile');
  decryptIfNeeded('profiles');
  decryptIfNeeded('state');
  decryptIfNeeded('renewEntitlements');
  decryptIfNeeded('frToken');
  decryptIfNeeded('deviceId');
  decryptIfNeeded('notificationsPermission');
}
